import actions from '../../../constants/actionTypes';
import {
  EnumPayByTypeNowShip,
  EnumPaymentMethodNowShip,
  transEnum,
} from '../../../constants/enum';

const initialState = () => ({
  input: {
    bookingServiceType: null,
    senderInfoAddress: null,
    senderInfoName: '',
    senderInfoPhone: '',
    receiverInfoAddress: null,
    receiverInfoName: '',
    receiverInfoPhone: '',
    distance: null,
    pickTime: null,
    isASAP: true,
    payByType: transEnum(EnumPayByTypeNowShip.SENDER),
    cod: null,
    note: null,
    imageParcels: [],
    paymentMethod: EnumPaymentMethodNowShip.COD,
    promoteCode: null,
    allowAutoApply: true,
    senderParkingFee: 0,
    receiverParkingFee: 0,
  },
  data: {
    locationInfo: {},
    availableTime: {},
    shipperOnMap: [],
    shippingFee: {},
    merchantBalance: {},
  },
});

function nowShipBookingReducer(state = initialState(), action) {
  const { response, type } = action;
  switch (type) {
    case actions.CHANGE_MULTI_INPUT_BOOKING_NOW_SHIP: {
      const mInputs = Object.keys(response).reduce(
        (inputs, inputKey) => ({
          ...inputs,
          [inputKey]:
            response[inputKey] !== null && response[inputKey] !== undefined
              ? response[inputKey]
              : initialState().input[inputKey],
        }),
        {},
      );
      return {
        ...state,
        input: {
          ...state.input,
          ...mInputs,
        },
      };
    }
    case actions.CHANGE_INPUT_BOOKING_NOW_SHIP: {
      const { name, value } = response;
      return {
        ...state,
        input: {
          ...state.input,
          [name]: value || initialState().input[name],
        },
      };
    }
    case actions.CHANGE_DATA_BOOKING_NOW_SHIP: {
      const { name, value } = response;
      return {
        ...state,
        data: {
          ...state.data,
          [name]: value || initialState().data[name],
        },
      };
    }
    case actions.RESET_STATE_BOOKING_NOW_SHIP: {
      return {
        ...initialState(),
      };
    }
    default: {
      return state;
    }
  }
}

export default nowShipBookingReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/NowShip/BookingNowShip/reducers.js